<div class="flex flex-col w-full h-full">
    <label
        class="text-base font-medium mb-1"
        *ngIf="config?.label !== null"
        [for]="config?.id"
        >{{ config?.label }}</label
    >
    <ng-template [ngIf]="!control" [ngIfElse]="formReactiveField">
        <textarea
            class="w-full h-full rounded-lg"
            [name]="config?.name ?? ''"
            [id]="config?.id ?? ''"
            cols="30"
            rows="10"
            [(ngModel)]="value"
            (ngModelChange)="onChangeListener($event)"
        ></textarea>
    </ng-template>
    <ng-template #formReactiveField>
        <textarea
            class="w-full h-full rounded-lg"
            [id]="config?.id ?? ''"
            [name]="config?.name ?? ''"
            cols="30"
            rows="10"
            [formControl]="control"
        ></textarea>
        <div
            *ngIf="control.invalid && (control.dirty || control.touched)"
            class="alert alert-error mt-1"
        >
            <div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>
                <span> The text used for tts is required! </span>
            </div>
        </div>
    </ng-template>
</div>
